module.exports = __webpack_public_path__ + "static/media/Mitchell Rock Utah.c6f658cd.png";